
import React, { useEffect, useState } from "react";
import { fetchAllNotifications } from "../services/notificationService";
import type { NotificationDoc } from "../types/legalOps";
import { DataToolbar } from "../components/DataToolbar";

export function NotificationHistoryPage() {
  const [items, setItems] = useState<NotificationDoc[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    fetchAllNotifications(100)
      .then(setItems)
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <div style={{ flexShrink: 0 }}>
        <DataToolbar 
          title="歷史通知紀錄" 
          canEdit={false} 
          onCreate={() => {}} 
          onExport={() => {}} 
        />
        <div className="p" style={{marginBottom: 16}}>
          顯示最近 100 筆通知紀錄 (含已讀與過期)
        </div>
      </div>

      <div style={{ 
          padding: 0, 
          flex: 1, 
          overflow: 'hidden', 
          display: 'flex', 
          flexDirection: 'column', 
          background: '#161616', 
          border: '1px solid var(--border)',
          borderRadius: 16,
          width: '100%' // Ensure full width
      }}>
        {/* Header Row (Desktop Only via CSS) */}
        <div className="history-grid-header">
          <div>日期</div>
          <div>類型</div>
          <div>標題 / 內容</div>
          <div style={{textAlign: 'right'}}>狀態</div>
        </div>

        <div style={{ overflowY: 'auto', flex: 1 }}>
          {loading && (
             <div style={{padding: 40, textAlign: 'center', color: 'var(--muted)'}}>
               載入中...
             </div>
          )}
          
          {!loading && items.length === 0 && (
             <div style={{padding: 40, textAlign: 'center', color: 'var(--muted)'}}>
               無紀錄
             </div>
          )}

          {!loading && items.map(n => (
            <div key={n.id} className="history-grid-row">
              {/* Col 1: Date */}
              <div style={{ color: 'var(--muted)', fontSize: 13, display:'flex', alignItems:'center', height:'100%' }}>
                {n.createdAt?.toDate ? n.createdAt.toDate().toLocaleString('zh-TW', { year:'numeric', month:'2-digit', day:'2-digit', hour:'2-digit', minute:'2-digit'}) : n.eventDate}
              </div>
              
              {/* Col 2: Type */}
              <div style={{ display:'flex', alignItems:'center', height:'100%' }}>
                <span className="badge">{n.category}</span>
              </div>
              
              {/* Col 3: Content */}
              <div style={{minWidth: 0}}>
                <div style={{ fontWeight: 500, color: '#fff', fontSize: 14, marginBottom: 4 }}>
                  {n.title}
                </div>
                <div style={{ fontSize: 13, color: '#9ca3af', lineHeight: 1.5 }}>
                  {n.detail}
                </div>
              </div>
              
              {/* Col 4: Status */}
              <div style={{ textAlign: 'right' }}>
                <span className={`badge`} style={{ 
                    background: n.read ? 'transparent' : 'rgba(251, 191, 36, 0.1)',
                    color: n.read ? 'var(--muted)' : '#fbbf24',
                    borderColor: n.read ? 'var(--border)' : '#fbbf24',
                    display: 'inline-block'
                }}>
                    {n.read ? "已讀" : "未讀"}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
